import React, {useState} from "react";
import {Button} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import {AddLead} from "./AddLead";

export const AdminAddLead = () => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <Button variant={"success"} onClick={handleShow}>
                Lägg till lead
            </Button>


            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header>
                    <Modal.Title>Lägg till lead</Modal.Title>
                </Modal.Header>
                <Modal.Body>


                    <AddLead />


                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Stäng
                    </Button>

                </Modal.Footer>
            </Modal>

        </>
    )
}
